<template>
  <vz-row class="vz-order-members pdf-order-section">
    <div class="color-light text-h1 mb-20 w-100">
      Участники
    </div>
    <vz-order-members
      v-if="!hideDispatch"
      :disabled="orderLockState.dispatch"
      use-send-code
      title-card="Отправитель"
      direction="dispatch"
      class="vz-direction-card mb-20"
    />
    <template v-if="!hideDispatch && !hideDestination">
      <img
          v-if="!lockSwap"
          ref="fluidPopupTarget"
          src="/svg/vz-swap-arrow-red.svg"
          class="vz-order-members-swap-btn"
          @click="onSwapMembers"
      >
      <vz-fluid-popup
        v-if="fluidPopupTarget"
        v-model="isFluidPopupShow"
        :target="fluidPopupTarget"
        centered
      >
        <div class="vz-fluid-popup--line" @click="onClickSwapMembers('swap')"><span>Поменять местами</span></div>
        <div class="vz-fluid-popup--line" @click="onClickSwapMembers('disToDes')"><span>Скопировать Отправителя в Получателя</span></div>
        <div class="vz-fluid-popup--line" @click="onClickSwapMembers('desToDis')"><span>Скопировать Получателя в Отправителя</span></div>
      </vz-fluid-popup>
    </template>

    <vz-order-members
      v-if="!hideDestination"
      :disabled="orderLockState.destinationCustomer"
      use-send-code
      title-card="Получатель"
      direction="destination"
      class="vz-direction-card mb-20"
    />

    <vz-order-members
      v-if="(isPayerThird || segregatedHasThirdPayer)"
      :disabled="orderLockState.payer"
      title-card="Третье лицо"
      direction="third"
      class="vz-direction-card"
    />
  </vz-row>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useOrderStore } from '~/stores/order'
import {OrderForm, OrderLockState} from '~/types/types';
import VzOrderMembers from './vz-order-members.vue'
import { deepCopyObject } from '~~/common/functions';
import VzRow from "~/components/ui-kit/vz-row.vue";
import VzFluidPopup from "~/components/ui-kit/vz-fluid-popup.vue";

const fluidPopupTarget = ref<HTMLElement>()
const isFluidPopupShow = ref(false)

const { orderForm } = storeToRefs(useOrderStore())
const props = defineProps({
  titleCard: {
    type: String,
    default: ''
  },
  hideDispatch: {
    type: Boolean,
    default: false
  },
  hideDestination: {
    type: Boolean,
    default: false
  },
})

const orderLockState = ref<OrderLockState>({
  destination:true,
  destinationCustomer:true,
  dispatch:true,
  payer:true,
})
const customer = computed((): OrderForm['customer'] => {
  return orderForm.value.customer
})

const isCloned = computed((): boolean => {
  const route = useRoute()
  return !!route.query.clone || false
})

const isPayerThird = computed((): boolean => {
  return orderForm.value.customer.payer === 'third'
})

const lockPayerDispatch = computed((): boolean => {
  return orderLockState.value.payer && orderForm.value.customer.payer === 'dispatch'
})

const lockPayerDestination = computed((): boolean => {
  return orderLockState.value.payer && orderForm.value.customer.payer === 'destination'
})

const lockSwap = computed((): boolean => {
  return orderLockState.value.dispatch || orderLockState.value.destination || lockPayerDestination.value || lockPayerDispatch.value
})

const isSegregated = computed((): boolean => {
  return orderForm.value.customer.payer === 'segregated'
})

const segregatedHasThirdPayer = computed((): boolean => {
  const { list } = orderForm.value.customer.segregated
  let hasThirdPayer = false
  Object.keys(list).forEach((key) => {
    if (list[key] === 'third') {
      hasThirdPayer = true
    }
  })
  return hasThirdPayer && isSegregated.value
})

onMounted((): void => {
  orderLockState.value = orderForm.value?.meta?.lockState || {}
})

function onSwapMembers(): void {
  isFluidPopupShow.value = true
}

function onClickSwapMembers(type: 'swap' | 'desToDis' | 'disToDes') {
  isFluidPopupShow.value = false

  if (type === 'swap' && orderForm.value.customer.projectGuid && ['dispatch', 'destination'].includes(orderForm.value.customer.payer)) {
    orderForm.value.customer.payer = orderForm.value.customer.payer === 'dispatch' ? 'destination' : 'dispatch'
    // логика смены будет работать в vz-order-payer-project
    return;
  }

  switch (type) {
    case 'swap': {
      const {
        dispatch,
        payer,
        segregated,
        destination,
        third,
        projectGuid
      } = deepCopyObject(orderForm.value.customer)

      orderForm.value.customer = {
        payer,
        segregated,
        projectGuid,
        dispatch: destination,
        destination: dispatch,
        third
      }
      break;
    }
    case 'desToDis':
      const {
          destination,
      } = deepCopyObject(orderForm.value.customer)

        orderForm.value.customer.dispatch = destination
        break;

      case 'disToDes':
      const {
          dispatch,
        } = deepCopyObject(orderForm.value.customer)

        orderForm.value.customer.destination = dispatch
        break;
  }
}
</script>
